import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { getFounderTypes } from "../../network/lib/masterData.js";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  founderObject,
  save,
  update,
  deleteLive,
  deletePreview,
  publish,
  getPreviewByFounderType,
  getLiveByFounderType,
} from "../../network/lib/founder.js";

function MandalFounder({ user }) {
  const [mandalFounderTypes, setMandalFounderTypes] = useState();
  const [mandalFounderType, setMandalFounderType] = useState("1");
  const [previewMandalFounderType, setPreviewMandalFounderType] = useState("1");
  const [liveMandalFounderType, setLiveMandalFounderType] = useState("1");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !mandalFounderTypes && populateMandalFounderTypes();
  }, []);

  const populateMandalFounderTypes = () => {
    getFounderTypes().then((res) => {
      if (res.status == 200) {
        setMandalFounderTypes(res.data);
        setPreviewMandalFounderType(res.data);
        setLiveMandalFounderType(res.data);
      }
    });
  };

  const setToDefault = () => {
    setMandalFounderType("1");
    setTitle("");
    setDescription("");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setMandalFounderType(params.founderTypeId);
      setTitle(params.title);
      setDescription(params.description);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (title == "") {
      message.innerHTML = "Please provide Title";
    } else if (description == "") {
      message.innerHTML = "Please provide Designation";
    } else {
      showHideLoader(true);
      founderObject.id = id;
      founderObject.founderTypeId = mandalFounderType;
      founderObject.title = title;
      founderObject.description = description;
      founderObject.image = image;
      founderObject.userName = user.userName;

      if (id == 0) {
        save(founderObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(founderObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = (founderType) => {
    showHideLoader(true);
    getPreviewByFounderType(founderType)
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    setPreviewMandalFounderType("1");
    fetchPreviewData("1");
  };

  const fetchLiveData = (founderType) => {
    showHideLoader(true);
    getLiveByFounderType(founderType)
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    setLiveMandalFounderType("1");
    fetchLiveData("1");
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        founderObject.id = parseInt(params);
        founderObject.userName = user.userName;

        deletePreview(founderObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData(previewMandalFounderType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview"
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        founderObject.id = parseInt(params);
        founderObject.userName = user.userName;

        deleteLive(founderObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData(liveMandalFounderType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      founderObject.id = parseInt(params);
      founderObject.userName = user.userName;

      publish(founderObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData(previewMandalFounderType);
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Mandal Founders
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Founder Type</span>
            </td>
            <td colSpan={3}>
              {mandalFounderTypes && (
                <select
                  onChange={(e) => setMandalFounderType(e.target.value)}
                  value={mandalFounderType}
                  style={{ width: "322px" }}
                >
                  {mandalFounderTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="105" />
                )}
                value={title}
                onChangeText={(text) => {
                  setTitle(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Designation</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="105" />
                )}
                value={description}
                onChangeText={(text) => {
                  setDescription(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Photo</span>
            </td>
            <td>
              <label
                htmlFor="file-upload"
                className="custom-file-upload"
                style={{ width: "307px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="file-upload"
                accept="image/*"
                onChange={(e) => handleImage(e)}
              />
            </td>
            <td colSpan={2}>
              {image && (
                <img
                  src={image}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td style={{ textAlign: "right", paddingRight: "32px" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 6 : approver ? 5 : 4}>
                Preview
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 6 : approver ? 5 : 4}>
                <span>Founder Type: </span>
                {mandalFounderTypes && (
                  <select
                    onChange={(e) => {
                      setPreviewMandalFounderType(e.target.value);
                      fetchPreviewData(e.target.value);
                    }}
                    value={previewMandalFounderType}
                    style={{ width: "322px" }}
                  >
                    {mandalFounderTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Designation</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.title}</td>
                  <td>{x.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image} style="width: 60px" />`)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 6 : approver ? 5 : 4}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 4 : 3}>
                Live
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 4 : 3}>
                <span>Founder Type: </span>
                {mandalFounderTypes && (
                  <select
                    onChange={(e) => {
                      setLiveMandalFounderType(e.target.value);
                      fetchLiveData(e.target.value);
                    }}
                    value={liveMandalFounderType}
                    style={{ width: "322px" }}
                  >
                    {mandalFounderTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Designation</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.title}</td>
                  <td>{x.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image} style="width: 60px" />`)}
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 4 : 3} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default MandalFounder;
